import styled from 'styled-components';
import theme from '@styles/theme';

import { RegularFont } from '@components/styled/StyledComponents';

export const Wrapper = styled.div<{ $margin?: string }>`
    margin: ${({ $margin }) => ($margin ? $margin : '150px auto')};
    width: 343px;
`;
export const Title = styled.h2`
    ${theme.typography.headline1}
    margin: 0 0 32px;
    font-family: PretendardBold, sans-serif;
`;
export const Hyphen = styled(RegularFont)`
    line-height: 50px;
    color: ${theme.colors.ultraLightGrayFontColor};
`;
